/**
 * Created by sdielmann on 30.11.2017.
 */
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding, Inject, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MuiAnimationTiming } from '../utility';
import { MuiAccordionProvider } from './mui-accordion.component';


@Component({
  selector: 'mui-accordion-content',
  styles: [
    `
      :host {
        display: block;
      }

      .mui-accordion__content {
        overflow: hidden;
      }

    `
  ],
  template: `
    <div
      class="mui-accordion__content"
      [class.hidden]="!parent.expanded"
      [@accordion]="animationState"
      (@accordion.done)="onAnimationDone()">
      @if (renderedContent) {
        <ng-content></ng-content>
      }
    </div>
  `,
  animations: [
    trigger('accordion', [
      state('open', style({ opacity: 1, height: '*', visibility: 'visible' })),
      state('closed', style({ opacity: 0, height: 0, visibility: 'hidden' })),
      transition('open <=> closed', animate(MuiAnimationTiming.EASE))
    ])
  ]
})
export class MuiAccordionContent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  animationState: 'open' | 'closed' = 'closed';
  renderedContent: boolean;

  @HostBinding('attr.id')
  get id(): string {
    return `${this.parent.id}_content`;
  }

  @HostBinding('attr.role')
  readonly role = 'region';

  @HostBinding('attr.aria-labelledby')
  protected get ariaControls(): string {
    return `${this.parent.id}_header`;
  }

  @HostBinding('attr.aria-hidden')
  protected get hidden(): boolean {
    return !this.parent.expanded;
  }

  constructor(@Inject(MuiAccordionProvider) public parent: MuiAccordionProvider) {
    this.animationState = parent.expanded ? 'open' : 'closed';
    this.renderedContent = parent.expanded || !parent.contentUnmounted;

    parent.expandedStateChanged
      .pipe(takeUntil(this.destroy$))
      .subscribe(expanded => {
        this.animationState = expanded ? 'open' : 'closed';

        this.renderedContent = expanded || !parent.contentUnmounted;
      });
  }

  onAnimationDone(): void {
    if (this.animationState === 'closed' && this.parent.contentUnmounted) {
      this.renderedContent = false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
